// extracted by mini-css-extract-plugin
module.exports = {"section":"K6_section__aMkrZ"};